module.exports = __webpack_public_path__ + "./assets/realtor_logo.png";